import React, { useEffect, useState } from 'react';
import useFetch from '../../services/useFetch.js'
import { DataGrid } from '@mui/x-data-grid'
import CircularProgress from '@mui/material/CircularProgress'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { dataGridSx } from '../ui/dataGridStyles'
import { tokens } from '../../theme'

export default function VendorTable({ startDate, endDate, reload }) {
  const [row, setRow] = useState([]);
  const [col, setCol] = useState([]);
  const { data, load } = useFetch(
    `api/vendor-costs?startDateStr=${startDate}&endDateStr=${endDate}`,
    reload,
  );

  useEffect(() => {
    if (data == null) return;
    setRow(
      data.map((e) => ({
        id: e.vendor,
        col1: e.vendor,
        col2: `$${e.vendorPurchasePrice.toFixed(2)}`,
        col3: `$${e.vendorAvgPurchasePrice.toFixed(2)}`,
      })),
    );
    setCol([
      { field: 'col1', headerName: 'Vendor', flex: 1.2 },
      { field: 'col2', headerName: 'Total spent', flex: 1 },
      { field: 'col3', headerName: 'Average', flex: 1 },
    ]);
  }, [data]);

  return (
    <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <Typography
        sx={{
          px: 2,
          pt: 2,
          pb: 1.25,
          fontWeight: 650,
          color: tokens.ink,
          fontFamily: "'Fraunces', 'Figtree', serif",
          fontSize: 18,
        }}
      >
        Spending by vendor
      </Typography>
      <Box sx={{ flex: 1, minHeight: 320, px: 1, pb: 1 }}>
        {load ? (
          <Box sx={{ display: 'grid', placeItems: 'center', height: '100%' }}>
            <CircularProgress size={28} />
          </Box>
        ) : (
          <DataGrid
            rows={row}
            columns={col}
            rowHeight={40}
            pageSizeOptions={[10, 25]}
            initialState={{ pagination: { paginationModel: { pageSize: 10 } } }}
            sx={{ ...dataGridSx, border: 'none', height: '100%' }}
            disableRowSelectionOnClick
          />
        )}
      </Box>
    </Box>
  );
}
